export class GeoJSON {
    constructor(geojson) {
        this.type = geojson.type;
        for (const key in geojson) {
            this[key] = geojson[key];
        }
    }
    toString() {
        return JSON.stringify(this);
    }
    static create(geojson) {
        switch (geojson.type) {
            case 'Feature':
                return new GeoJSONFeature(geojson);
            case 'FeatureCollection':
                return new GeoJSONFeatureCollection(geojson);
            case 'GeometryCollection':
                return new GeoJSONGeometryCollection(geojson);
            case 'Point':
                return new GeoJSONPoint(geojson);
            case 'MultiPoint':
                return new GeoJSONMultiPoint(geojson);
            case 'LineString':
                return new GeoJSONLineString(geojson);
            case 'MultiLineString':
                return new GeoJSONMultiLineString(geojson);
            case 'Polygon':
                return new GeoJSONPolygon(geojson);
            case 'MultiPolygon':
                return new GeoJSONMultiPolygon(geojson);
        }
    }
    static createFromGeoJSONString(geojsonString) {
        let object = null;
        try {
            object = JSON.parse(geojsonString);
        }
        catch (err) {
            throw Error('Could not create GeoJSON from geojsonString - incorrect json string');
        }
        if (!object) {
            return null;
        }
        return GeoJSON.create(object);
    }
}
export class GeoJSONFeature extends GeoJSON {
    constructor(geojson) {
        super(geojson);
        this.type = 'Feature';
        this.geometry = geojson.geometry;
        this.properties = geojson.properties ?? {};
    }
}
export class GeoJSONFeatureCollection extends GeoJSON {
    constructor(geojson) {
        super(geojson);
        this.type = 'FeatureCollection';
        this.features = geojson.features ?? [];
    }
}
export class GeoJSONGeometryCollection extends GeoJSON {
    constructor(geojson) {
        super(geojson);
        this.type = 'GeometryCollection';
        this.geometries = geojson.geometries;
    }
}
export class GeoJSONLineString extends GeoJSON {
    constructor(geojson) {
        super(geojson);
        this.type = 'LineString';
        this.coordinates = geojson.coordinates;
    }
}
export class GeoJSONMultiLineString extends GeoJSON {
    constructor(geojson) {
        super(geojson);
        this.type = 'MultiLineString';
        this.coordinates = geojson.coordinates;
    }
}
export class GeoJSONMultiPoint extends GeoJSON {
    constructor(geojson) {
        super(geojson);
        this.type = 'MultiPoint';
        this.coordinates = geojson.coordinates;
    }
}
export class GeoJSONMultiPolygon extends GeoJSON {
    constructor(geojson) {
        super(geojson);
        this.type = 'MultiPolygon';
        this.coordinates = geojson.coordinates;
    }
}
export class GeoJSONPoint extends GeoJSON {
    constructor(geojson) {
        super(geojson);
        this.type = 'Point';
        this.coordinates = geojson.coordinates;
    }
}
export class GeoJSONPolygon extends GeoJSON {
    constructor(geojson) {
        super(geojson);
        this.type = 'Polygon';
        this.coordinates = geojson.coordinates;
    }
}
